(function () {
    var FuelLimitCtrl = (function () {
        function FuelLimitCtrl() {
            this.init.apply(this, arguments);
        }

        FuelLimitCtrl.prototype = {
            init: function ($scope, $state, $rootScope, $stateParams, localStorageService, $mdDialog, $ionicScrollDelegate, $timeout, MKioskService, $message, $q) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.MKioskService = MKioskService;
                this.$message = $message;
                this.$q = $q;
                
                this.loadData().then(angular.bind(this, function (limit) {
                    this.myFuelLimit = limit; 
                }));
            },
            back: function () {
                let router = "internal.home";
                if (this.$stateParams.prevState)
                    router = this.$stateParams.prevState;
                this.$state.go(router);
            },
            loadData: function () {
                return this.MKioskService.getMyFuelLimit();
            }            
        };
        FuelLimitCtrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'localStorageService', '$mdDialog', '$ionicScrollDelegate', '$timeout', 'MKioskService', '$message', '$q'];
        return FuelLimitCtrl;
    }());
    angular.module('internal.fuellimit').controller('FuelLimitCtrl', FuelLimitCtrl)
})();


